import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import { userSelectDate, userSelectHall } from "recoil/atoms";
import {
  BottomButton,
  GridList,
  Layout,
  TagList,
  Title,
  ToggleBox,
  Textarea,
  StickyContent,
} from "../../components";
import moment from "moment";
import { IGridData } from "components/GridList/GridList";
import { getParameterObject } from "utils/common";
import styles from "./style.module.css";

export type tMonth = {
  [key: string]: string[];
};

interface IMonth {
  year: string;
  month: string;
  value: string;
}

interface IGroupYear {
  year: string;
  month: IMonth[];
}

const weekdayList: IGridData[] = [
  { label: "금요일", value: "금요일" },
  { label: "토요일", value: "토요일" },
  { label: "일요일", value: "일요일" },
  { label: "그 외", value: "그 외" },
];
const timeList: IGridData[] = [
  { label: "10시~12시", value: "10시~12시" },
  { label: "12시~14시", value: "12시~14시" },
  { label: "14시~16시", value: "14시~16시" },
  { label: "16시 이후", value: "16시 이후" },
];
const headCountList: IGridData[] = [
  { label: "50명 미만", value: "50명 미만" },
  { label: "50~100명", value: "50~100명" },
  { label: "100~150명", value: "100~150명" },
  { label: "150~200명", value: "150~200명" },
  { label: "200~250명", value: "200~250명" },
  { label: "250~300명", value: "250~300명" },
  { label: "300~350명", value: "300~350명" },
  { label: "350~400명", value: "350~400명" },
  { label: "400~450명", value: "400~450명" },
  { label: "450~500명", value: "450~500명" },
  { label: "500명 이상", value: "500명 이상" },
];
const headCountOptionList: IGridData[] = [
  { label: "+50명 까지 가능해요", value: "+50명 까지 가능해요" },
  { label: "+100명 까지 가능해요", value: "+100명 까지 가능해요" },
];

export default function WeddingDate() {
  const navigate = useNavigate();
  const [selectData, setSelectData] = useRecoilState(userSelectDate);
  const [groupYear, setGroupYear] = useState<IGroupYear[]>([]);
  const { search } = useLocation();
  const { txt } = getParameterObject({ url: search });
  const decodedTxt: string | undefined =
    decodeURIComponent(txt) === "undefined"
      ? undefined
      : decodeURIComponent(txt);
  const nonexistent = decodedTxt === "nonexistent";
  const [selectArray, setSelectArray] = useRecoilState(userSelectHall);

  const isComplete = !!nonexistent
    ? (selectData.wantWeddingHallName || []).length > 0 &&
      (selectData.wantToMonth || []).length > 0 &&
      (selectData.wantToTime || []).length > 0 &&
      (selectData.wantTotHeadCount || []).length > 0
    : (selectData.wantToMonth || []).length > 0 &&
      (selectData.wantToTime || []).length > 0 &&
      (selectData.wantTotHeadCount || []).length > 0;

  const handleItemClick = (item: string, propsValue: string) => {
    switch (propsValue) {
      case "wantWeddingMonth":
        setSelectData({
          ...selectData,
          wantToMonth: (selectData?.wantToMonth || []).filter(
            (data) => data !== item
          ),
        });
        break;
      case "wantDay":
        setSelectData({
          ...selectData,
          wantToDay: (selectData?.wantToDay || []).filter(
            (data) => data !== item
          ),
        });
        break;
      case "wantTime":
        setSelectData({
          ...selectData,
          wantToTime: (selectData?.wantToTime || []).filter(
            (data) => data !== item
          ),
        });
        break;
      case "wantHeadcount":
        setSelectData({
          ...selectData,
          wantTotHeadCount: (selectData?.wantTotHeadCount || []).filter(
            (data) => data !== item
          ),
        });
        break;
      case "wantHeadcountOption":
        setSelectData({
          ...selectData,
          wantToHeadCountOption: (
            selectData?.wantToHeadCountOption || []
          ).filter((data) => data !== item),
        });
        break;
      default:
        break;
    }
  };

  function initGroupYear() {
    // 날짜데이터 groupping
    const startMonth = moment(moment(), "YYYY-MM");
    const endMonth = moment(moment().add(24, "M"), "YYYY-MM");

    const groupData: IGroupYear[] = [];
    let currentMonth = startMonth.clone();

    while (currentMonth.isSameOrBefore(endMonth)) {
      const year = currentMonth.format("YYYY");
      const month = currentMonth.format("M");

      const yearIndex = groupData.findIndex((item) => item.year === year);
      const thisMonthData: IMonth = {
        year,
        month,
        value: `${year}년 ${month}월`,
      };
      if (yearIndex === -1) {
        groupData.push({ year, month: [thisMonthData] });
      } else {
        groupData[yearIndex].month.push(thisMonthData);
      }

      currentMonth.add(1, "M");
    }

    setGroupYear(groupData);
  }

  useEffect(() => {
    initGroupYear();
  }, []);

  useEffect(() => {
    if (!!nonexistent) {
      setSelectArray([]);
    }
  }, []);
  return (
    <>
      <Layout>
        <Title
          title="희망 예식 일정을\n알려주세요."
          subTitle="* 필수 입력 사항"
          style={{ marginBottom: 20 }}
        />
        {nonexistent && (
          <>
            <h5 style={{ color: "#333", fontSize: "16px", fontWeight: "700" }}>
              상담 희망 웨딩홀을 작성해주세요.*
            </h5>
            <div className={styles.nonExistent}>
              <li>∙ 웨딩홀 업체명</li>
              <input
                placeholder="ex) 더컨벤션 잠실점"
                value={selectData.wantWeddingHallName}
                onChange={(event) => {
                  setSelectData({
                    ...selectData,
                    wantWeddingHallName: event.target.value,
                  });
                }}
              />
            </div>
            <div className={styles.nonExistent}>
              <li>∙ 웨딩홀 홀명</li>
              <input
                placeholder="ex) 비스타홀"
                value={selectData.wantWeddingHallType}
                onChange={(event) => {
                  setSelectData({
                    ...selectData,
                    wantWeddingHallType: event.target.value,
                  });
                }}
              />
            </div>
          </>
        )}
        <ToggleBox
          buttonText="희망 예식월을 선택해주세요*"
          buttonSubCont="최대 3개 중복선택가능"
          toggleContent={
            <>
              {(groupYear || []).map((year, i) => (
                <GridList
                  key={i}
                  title={`${year.year}년`}
                  column={3}
                  list={(year.month || []).map((_month) => ({
                    label: `${_month.month}월`,
                    value: _month.value,
                  }))}
                  selectType="multi"
                  selectedValue={selectData.wantToMonth}
                  setValue={(value) => {
                    setSelectData({
                      ...selectData,
                      wantToMonth: value,
                    });
                  }}
                />
              ))}
            </>
          }
          bottomContent={
            <TagList
              list={selectData.wantToMonth}
              onClick={handleItemClick}
              propsValue="wantWeddingMonth"
            />
          }
        />

        <ToggleBox
          buttonText="희망 예식 요일을 선택해주세요"
          buttonSubCont="중복선택가능"
          toggleContent={
            <GridList
              column={3}
              list={weekdayList}
              selectedValue={selectData.wantToDay}
              setValue={(value) =>
                setSelectData({ ...selectData, wantToDay: value })
              }
              selectType="multi"
            />
          }
          bottomContent={
            <TagList
              list={selectData.wantToDay}
              onClick={handleItemClick}
              propsValue="wantDay"
            />
          }
        />
        <ToggleBox
          buttonText="희망 예식 시간을 선택해주세요*"
          buttonSubCont="중복선택가능"
          toggleContent={
            <GridList
              column={2}
              list={timeList}
              selectedValue={selectData.wantToTime}
              setValue={(value) => {
                setSelectData({
                  ...selectData,
                  wantToTime: value,
                });
              }}
              selectType="multi"
            />
          }
          bottomContent={
            <TagList
              list={selectData.wantToTime}
              onClick={handleItemClick}
              propsValue="wantTime"
            />
          }
        />

        <ToggleBox
          buttonText="희망 예식일 마감일 때 추가로 가능한 일정"
          toggleContent={
            <Textarea
              style={{
                height:
                  (selectData?.HeadCountOptionText || "").length > 0
                    ? !(selectData?.HeadCountOptionText || "").includes("\n")
                      ? 40
                      : (selectData?.HeadCountOptionText || "").split("\n")
                          .length * 20
                    : 115,
              }}
              placeholder={`희망 예식일 마감일 때, 추가 안내에 참고할 점을 알려주세요.\n3개월 넘는 기간 현황 문의는 안내가 불가해요.\nex) 9~11월 토요일이면 다른 날짜도 괜찮아요.\n명절 있는 주는 안돼요\nex) 토요일, 일요일 상관없이 점심 예식만 가능해요`}
              onChange={(e) =>
                setSelectData({
                  ...selectData,
                  HeadCountOptionText: e.target.value,
                })
              }
              value={selectData?.HeadCountOptionText || ""}
            />
          }
          // bottomContent={
          //   <TextField
          //     value="토요일, 일요일 상관없이 점심 예식만 가능해요"
          //     readOnly
          //   />
          // }
        />

        <ToggleBox
          buttonText="예상 하객수를 선택해주세요*"
          toggleContent={
            <GridList
              column={3}
              list={headCountList}
              selectedValue={selectData.wantTotHeadCount}
              setValue={(value) => {
                setSelectData({
                  ...selectData,
                  wantTotHeadCount: value,
                });
              }}
              selectType="single"
            />
          }
          bottomContent={
            <TagList
              list={selectData.wantTotHeadCount}
              onClick={handleItemClick}
              propsValue="wantHeadcount"
            />
          }
        />

        <ToggleBox
          hiddenBorder
          buttonText="예상 하객수에 맞는 일정이 없다면?"
          toggleContent={
            <GridList
              column={1}
              list={headCountOptionList}
              selectType="single"
              selectedValue={selectData.wantToHeadCountOption}
              setValue={(value) => {
                setSelectData({
                  ...selectData,
                  wantToHeadCountOption: value,
                });
              }}
            />
          }
          bottomContent={
            <TagList
              list={selectData.wantToHeadCountOption}
              onClick={handleItemClick}
              propsValue="wantHeadcountOption"
            />
          }
        />
      </Layout>

      <StickyContent type="bottom">
        <BottomButton
          nextButtonDisabled={isComplete ? false : true}
          prevButtonEvent={() => navigate(-1)}
          nextButtonEvent={() => {
            navigate("/counseling/date");
          }}
        />
      </StickyContent>
    </>
  );
}
